import { render, staticRenderFns } from "./TriggerSetup.vue?vue&type=template&id=19de0f5e&scoped=true&"
import script from "./TriggerSetup.vue?vue&type=script&lang=ts&"
export * from "./TriggerSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19de0f5e",
  null
  
)

export default component.exports